<template>
  <div id="smartTown" class="company-profile">
    <!-- 标题区域 -->
    <h1 class="profile-title">海南华德科技有限公司简介</h1>

    <!-- 正文内容区域 -->
    <div class="profile-content">
      <!-- 第1章 公司简介 -->
      <div class="text-section">
        <h2 class="chapter-title">第1章 公司简介</h2>
        <p class="content-paragraph">
          海南华德科技有限公司（简称“华德科技”）总部位于海口，注册资金1000万，获得国家级高新技术企业、国家科技型中小企业、海南省高新技术种子企业和海南省创新型中小企业等认证，拥有50余个软件著作权，坚持以市场为先导、技术为保障、服务为后盾，致力于为用户持续创造价值的创新型软件服务商。
        </p>

        <!-- 资质亮点条 -->
        <div class="highlight-bar">
          <div class="highlight-item">
            <div class="highlight-num">1000<span class="highlight-unit">万</span></div>
            <div class="highlight-label">注册资金</div>
          </div>
          <div class="highlight-item">
            <div class="highlight-num">50<span class="highlight-unit">+</span></div>
            <div class="highlight-label">软件著作权</div>
          </div>
          <div class="highlight-item">
            <div class="highlight-num">3<span class="highlight-unit">大</span></div>
            <div class="highlight-label">业务领域</div>
          </div>
        </div>

        <p class="content-paragraph">
          团队核心成员毕业于法国萨瓦大学、北京大学、华中科技大学、四川大学、湖南大学等国内外著名高校的计算机相关专业，有十几年的从业经验及许多大型项目成功经验，是一支具备高技术水平、高服务意识和丰富项目经验的团队，能为项目顺利落地提供有力的保障。
        </p>

        <!-- 公司能力体系图 -->
        <div class="image-container">
          <img
            src="@/assets/images/20250724/ruanjian/nengli.svg"
            class="capability-img"
            alt="海南华德科技有限公司能力体系图"
            loading="lazy"
          />
        </div>

        <p class="content-paragraph">
          华德科技致力成为专业的软件服务商，为用户持续创造价值。公司始终秉持市场导向的发展理念，紧扣大数据、云计算、人工智能等前沿科技脉搏，华德科技以数据为底座、以智能为引擎、以场景为牵引，凭借扎实的技术积累、丰富的项目经验和对行业业务的深度理解，为电子政务、数字企业与医疗健康三大领域的合作伙伴提供技术赋能。
        </p>
      </div>

      <!-- 第2章 公司优势 -->
      <div class="text-section">
        <h2 class="chapter-title">第2章 公司优势</h2>
        <div class="advantage-grid">
          <div class="advantage-card">
            <div class="adv-title"><span class="adv-no">1</span>高效的服务能力</div>
            <p class="adv-desc">我们是家深耕信息技术行业的高新技术企业，提倡高效工作、服务为先的工作原则，为用户提供贴合业务场景的产品及服务。</p>
          </div>
          <div class="advantage-card">
            <div class="adv-title"><span class="adv-no">2</span>先进的技术应用架构</div>
            <p class="adv-desc">采用微服务架构体系，具备数据中台与智能分析的产品能力，能为用户提供先进的架构保障体系和数据治理能力。</p>
          </div>
          <div class="advantage-card">
            <div class="adv-title"><span class="adv-no">3</span>资深的专家咨询服务</div>
            <p class="adv-desc">团队成员拥有多年大型项目建设经验，可指导用户业务系统进行顶层设计，提供专家咨询服务。</p>
          </div>
          <div class="advantage-card">
            <div class="adv-title"><span class="adv-no">4</span>完备的交付体系</div>
            <p class="adv-desc">采用精益管理模式，以循环瀑布式的方法响应客户需求，结合完善的测试体系，支撑项目按计划推进。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "smartTown",
  data() {
    return {};
  }
};
</script>

<style scoped>
/* 全局容器样式 */
.company-profile {
  max-width: 1200px;
  margin: 0 auto;
  /* 外层容器 上下间距大于左右 */
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.profile-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  /* 标题 下间距大于上间距 */
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.profile-content {
  background-color: var(--white);
  /* 内容区 上下内边距大于左右 */
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 - 上下间距差异化 */
.text-section {
  /* 章节 下间距大于上间距，区分章节层级 */
  margin: 20px 0 60px;
}
/* 最后一个章节取消底部大间距 */
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  /* 章节标题 下间距大于上间距 */
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 - 段落上下间距不同 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  /* 段落 下间距大于上间距，引导阅读流向 */
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}

/* 资质亮点条 */
.highlight-bar {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin: 24px 0 44px;
}
.highlight-item {
  background-color: var(--white);
  border-radius: 12px;
  border-bottom: 3px solid var(--primary-color1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  padding: 26px 12px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.highlight-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}
.highlight-num {
  font-family: "Cuprum", "Microsoft YaHei", sans-serif;
  font-size: 36px;
  font-weight: 700;
  color: var(--primary-color1);
  line-height: 1.1;
}
.highlight-unit {
  font-size: 16px;
  font-weight: 400;
  margin-left: 2px;
}
.highlight-label {
  margin-top: 8px;
  font-size: 14px;
  color: var(--text-color2);
}

/* 公司优势 - 2x2 卡片网格 */
.advantage-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin: 8px 0 22px;
}
.advantage-card {
  background-color: var(--white);
  border-radius: 12px;
  border-top: 3px solid var(--primary-color1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  padding: 24px 22px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.advantage-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}
.adv-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 17px;
  color: var(--text-color);
  margin-bottom: 10px;
}
.adv-no {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: var(--primary-color1);
  color: var(--white);
  font-size: 14px;
  font-weight: 700;
}
.adv-desc {
  margin: 0;
  font-size: 15px;
  line-height: 1.8;
  color: var(--text-color2);
  text-align: justify;
}

/* 图片容器 - 上下间距大于左右 */
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  /* 图片区 上下大间距，左右小间距 */
  margin: 40px 10px;
  padding: 25px 15px;
  background-color: var(--light-bg);
  border-radius: 8px;
}

/* 公司能力体系图 */
.capability-img {
  width: 80%;
  max-width: 820px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.capability-img:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

/* 响应式适配 - 保持间距差异化逻辑 */
@media (max-width: 768px) {
  .company-profile {
    padding: 30px 15px;
  }

  .profile-title {
    font-size: 26px;
    margin-bottom: 40px;
  }

  .profile-content {
    padding: 40px 20px;
  }

  .text-section {
    margin: 15px 0 50px;
  }

  .chapter-title {
    font-size: 18px;
    margin: 8px 0 20px;
  }

  .content-paragraph {
    font-size: 15px;
    line-height: 1.7;
    margin: 6px 0 18px;
  }

  .highlight-bar {
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    margin: 20px 0 36px;
  }
  .highlight-num {
    font-size: 30px;
  }
  .advantage-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .adv-desc {
    font-size: 14px;
    line-height: 1.7;
  }

  .image-container {
    margin: 30px 8px;
    padding: 20px 10px;
  }

  .capability-img {
    width: 90%;
  }
}

@media (max-width: 480px) {
  .company-profile {
    padding: 25px 10px;
  }

  .profile-title {
    font-size: 22px;
    margin-bottom: 30px;
  }

  .profile-content {
    padding: 30px 15px;
  }

  .text-section {
    margin: 10px 0 40px;
  }

  .content-paragraph {
    font-size: 14px;
    margin: 5px 0 15px;
  }

  .highlight-bar {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .highlight-num {
    font-size: 26px;
  }
  .highlight-label {
    font-size: 13px;
  }

  .image-container {
    margin: 25px 5px;
    padding: 15px 8px;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/CompanyIntroduction.vue